import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { userInitialState } from './constants';
import { UserDataType } from './types';
import usersApi from '../../api/UsersApi';
import { UserType } from '../../types/user.type';
import { isError } from '../../utils/isError';

export const fetchUser = createAsyncThunk<UserType, undefined, { rejectValue: string }>(
  'user/fetchUser',
  // @ts-ignore
  async function (_, { rejectWithValue, dispatch }) {
    try {
      return await usersApi.getUser();
    }
    catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState: userInitialState,
  reducers: {
    updateUser(state, action: PayloadAction<UserDataType>) {
      if (state.data) {
        Object.assign(state.data, action.payload);
      } else {
        state.data = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        const { vk_id, ...rest } = action.payload;

        if (state.data) {
          Object.assign(state.data, rest);
        } else {
          state.data = rest;
        }

        state.loading = false;
      })
      .addMatcher(isError, (state, action: PayloadAction<string>) => {
        state.error = action.payload;
        state.loading = false;
      });
  }
});

export const { updateUser } = userSlice.actions;

export default userSlice.reducer;
